import React from 'react'
import { mq } from 'marketing-site/src/library/utils'

export const BackgroundBlobBlueAndOrange = (): React.ReactElement => {
  return (
    <>
      <div className="background-blob-blue-and-orange">
        <img
          className="background-blob-blue-and-orange__gradient"
          src="https://images.ctfassets.net/xny2w179f4ki/1jsVvAVjU1LpZfVccHUz0f/da374c8f8fd2a37a0039be97bd3b8bde/Blob-main.webp"
          width="769"
          height="854"
          alt=""
        />
      </div>

      <style jsx>
        {`
          .background-blob-blue-and-orange {
            display: flex;
            width: 39rem;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-52%, 52%);
            z-index: 1;

            &__gradient {
              width: 100%;
              height: auto;
            }
          }

          @media (${mq.tablet}) {
            .background-blob-blue-and-orange {
              width: 48rem;
              transform: translate(-50%, 40%);
            }
          }

          @media (${mq.desktop}) {
            .background-blob-blue-and-orange {
              transform: translate(-19%, -2%);
            }
          }

          @media (${mq.desktopMid}) {
            .background-blob-blue-and-orange {
              transform: translate(-11%, -2%);
            }
          }
        `}
      </style>
    </>
  )
}
